import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { PortalRootContext } from "../../portal-root/PortalRootContext";
import * as Styled from "./MultiSelect.styled";
// should be enough for focus to be transferred back to button after an update,
// but might need to increase in the future if switched to aria-live="assertive"
export const MULTISELECT_LIVE_UPDATE_DELAY = 0;
export const MULTISELECT_LIVE_UPDATE_TIMEOUT = 5000;
export const MultiSelectAriaContainer = (props) => {
    const portalRoot = useContext(PortalRootContext);
    const { ariaContainerValue } = props;
    const [textToAnnounce, setTextToAnnounce] = useState("");
    const renderedText = process.env.NODE_ENV === "test" ? ariaContainerValue : textToAnnounce;
    useEffect(() => {
        if (process.env.NODE_ENV === "test") {
            // do not use this in tests, render message directly
            return;
        }
        const liveRegionUpdate = window.setTimeout(() => requestAnimationFrame(() => setTextToAnnounce(ariaContainerValue ?? "")), MULTISELECT_LIVE_UPDATE_DELAY);
        // Clearing the status container is good practice:
        // We already have a list of selected items either on the combobox trigger or in ToggleOptionWrapper's list items,
        // so keeping the last status update accessible in browse mode after you've left the menu isn't neccesary and might be confusing
        const liveRegionClear = window.setTimeout(() => setTextToAnnounce(""), MULTISELECT_LIVE_UPDATE_TIMEOUT);
        return () => {
            clearTimeout(liveRegionUpdate);
            clearTimeout(liveRegionClear);
        };
    }, [ariaContainerValue]);
    return portalRoot ? (_jsx(_Fragment, { children: ReactDOM.createPortal(_jsx(Styled.AriaUpdateContainer, { children: renderedText }), portalRoot) })) : null;
};
